import React, { useState } from 'react';
import AuthService from '../../../services/AuthService';
import './modal.css';
import "@fortawesome/fontawesome-free/css/all.css";

const Modal = ({ data, onClose, onReprocess }) => {
    if (!data) return null;

    const allAvailable = data.certidoes.every(certidao => certidao.uuid && certidao.uuid !== "ERRO" && certidao.uuid !== "reprocessamento");

    const handleDownloadCertidao = async (uuid, nomeCertidao) => {
        try {
            await AuthService.downloadArquivo(uuid, nomeCertidao);
        } catch (error) {
            alert('Erro ao baixar a certidão.');
        }
    };

    const handleDownloadAll = async () => {
        const uuids = data.certidoes.map(certidao => certidao.uuid);
        try {
            await AuthService.downloadArquivosZip(uuids);
        } catch (error) {
            alert('Erro ao baixar todas as certidões.');
        }
    };

    const [reprocessando, setReprocessando] = useState(false);

    const handleReprocessar = async (id_pedido) => {
        if (reprocessando) return;
        setReprocessando(true);
        try {
            const result = await AuthService.reprocessarPedido(id_pedido);
            if (result.success) {
                onClose();
                if (onReprocess) onReprocess();
            } else {
                alert(result.message || 'Erro ao reprocessar.');
            }
        } catch (error) {
            alert('Erro ao reprocessar a certidão.');
        } finally {
            setReprocessando(false);
        }
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        const formattedTime = date.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        return `${formattedDate} às ${formattedTime}`;
    };

    const hasFiveMinutesPassed = (dateString) => {
        const creationDate = new Date(dateString);
        const now = new Date();
        return (now - creationDate) > (5 * 60 * 1000); // 5 minutes in milliseconds
    };

    const handleBackdropClick = (event) => {
        if (event.target.className === 'modal-backdrop') {
            onClose();
        }
    };

    const specialModelIds = ['58', '54', '94', '3', '41', '52', '6', '97'];

    return (
        <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal-content">
                <h3>Certidões de {data.cpf ? data.nome : data.nome_empresa}</h3>
                <div className="date-download-container">
                    <p>
                        {data.cpf ? <strong>CPF:</strong> : <strong>CNPJ:</strong>} {data.cpf || data.cnpj}
                    </p>
                    <p><strong>Data da Solicitação:</strong> {formatDateTime(data.creation_date)}</p>
                </div>
                {allAvailable && (
                    <div className="download-all-container" onClick={handleDownloadAll}>
                    <i className="fas fa-file-archive download-all-icon" />
                    <span className="download-all-text">Baixar Todos</span>
                    </div>
                )}
                <ul>
                    {data.certidoes.map((certidao, index) => (
                        <li key={index} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            <strong>{certidao.nome_certidao}</strong>:
                            {certidao.uuid === "REPROCESSAMENTO" ? (
                                <span style={{ color: "white", marginLeft: '10px' }}>Em processamento...</span>
                            ) : certidao.uuid === "CONSTA APONTAMENTO" ? (
                                <span style={{ color: "green", marginLeft: '10px' }}>
                                    Consta Apontamento
                                </span>
                            ) : certidao.uuid === "NADA CONSTA" ? (
                                <span style={{ color: "green", marginLeft: '10px' }}>
                                    Nada Consta
                                </span>
                            ) : certidao.uuid === "ERRO" ? (
                                <span style={{ color: "#E8A838", marginLeft: '10px' }}>
                                    Não foi possível executar esta operação, tente novamente mais tarde
                                </span>
                            ) : certidao.uuid && certidao.uuid !== "reprocessamento" ? (
                                <i 
                                    className="fas fa-download download-icon"
                                    style={{ cursor: 'pointer', marginLeft: '10px' }}
                                    onClick={() => handleDownloadCertidao(certidao.uuid, certidao.nome_certidao)}
                                />
                            ) : specialModelIds.includes(certidao.model_id.toString()) && hasFiveMinutesPassed(data.creation_date) ? (
                                <span style={{ color: "white", marginLeft: '10px' }}>Em processamento...</span>
                            ) : !specialModelIds.includes(certidao.model_id.toString()) && hasFiveMinutesPassed(data.creation_date) ? (
                                <span style={{ color: "white", marginLeft: '10px' }}>Em processamento...</span>
                            ) : (
                                <span style={{ color: "white", marginLeft: '10px' }}>Em processamento...</span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Modal;
